export const SET_HOSPITALS_TYPES = 'SET_HOSPITALS_TYPES';

export default {
  [SET_HOSPITALS_TYPES]: (state, data) => {
    state.hospitalsTypes = data.items;
  },
};
